import { useMutation } from '@tanstack/react-query';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useResetPassword() {
  return useMutation<RespondedType, ResponseError, string>({
    mutationKey: ['/UpdatePassword'],
    mutationFn: (params) => fetcher<RespondedType>('/UpdatePassword', { Password: params }),
    retry: false,

    onError: (error) => {
      addToast({
        type: 'error',
        message: error.message,
      });
    },
  });
}
